module.exports = __webpack_public_path__ + "font/open-sans-bold.f24f4bc.woff";